export enum RenovationLabelEnum {
	COMPLETE = "complete",
	REFRESH = "rafraichissement",
	ENERGIE = "energetique",
	TOTALE = "totale"
}
